import { Link } from 'react-router-dom';
import { assetUrl } from '../../../services/storefrontService.js';
import Price from '../../common/Price.jsx';

export default function ProductCard({ product }) {
  const available = product.quantity > 0;

  return (
    <article className="product-card">
      <div className="product-media-shell">
        <Link className="product-media" to={`/product/${product.id}`}>
          {!available ? <span className="oos-chip">Sold out</span> : null}
          <img src={assetUrl(product.image)} alt={product.name} loading="lazy" />
        </Link>
      </div>
      <div className="product-copy">
        <Link className="product-title" to={`/product/${product.id}`}>{product.name}</Link>
        <div className="product-card-bottom">
          <Price current={product.currentPrice} old={product.oldPrice} />
          {product.hasDiscount ? <span className="product-sale-badge">-{product.discountPercent}%</span> : null}
        </div>
      </div>
    </article>
  );
}
